import React from 'react';
import { X, Factory, TrendingUp, Package, Trophy } from 'lucide-react';

export default function ProducaoTotal({ data, onClose }) { 

  const formatCurrency = (value) => 
    Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  // Formatador para volume m³
  const formatVolume = (value) => 
    Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + " m³";

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Cabeçalho */}
        <div className="flex justify-between items-center p-4 border-b border-gray-800 bg-[#161b22]">
          <div className="flex items-center gap-2 text-cyan-400 font-bold tracking-widest text-xs uppercase">
            <Factory size={18} />
            <span>Detalhamento de Produção</span>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Conteúdo em Grid */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          
          {/* Card: Produção do Dia */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <p className="text-gray-500 text-[10px] uppercase font-bold mb-2 italic tracking-tighter">Produção do Dia</p>
            <p className="text-white text-2xl font-mono font-bold">
              {formatCurrency(data?.producaoDia)}
            </p>
          </div>

          {/* Card: Produção Acumulada (R$) */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <p className="text-gray-500 text-[10px] uppercase font-bold mb-2 italic tracking-tighter">Acumulado do Mês (Financeiro)</p>
            <p className="text-cyan-400 text-2xl font-mono font-bold">
              {formatCurrency(data?.producaoMes)}
            </p>
          </div>

          {/* NOVO: Card Produção Total m³ */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Produção Total do Dia m³</p>
              <Package size={14} className="text-gray-600" />
            </div>
            <p className="text-white text-2xl font-mono font-bold tracking-tighter">
              {formatVolume(data?.producaoDiaM3 || 0)}
            </p>
          </div>
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Produção Total do Mês m³</p>
              <Package size={14} className="text-gray-600" />
            </div>
            <p className="text-white text-2xl font-mono font-bold tracking-tighter">
              {formatVolume(data?.producaoTotalM3 || 0)}
            </p>
          </div>

          {/* NOVO: Card Maior Produção */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Maior Produção do Mês</p>
              <Trophy size={14} className="text-amber-500 opacity-70" />
            </div>
            <p className="text-amber-500 text-2xl font-mono font-bold tracking-tighter">
              {formatCurrency(data?.producaoMaior || 0)}
            </p>
          </div>
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Maior Produção do Mês m³</p>
              <Trophy size={14} className="text-amber-500 opacity-70" />
            </div>
            <p className="text-amber-500 text-2xl font-mono font-bold tracking-tighter">
              {formatCurrency(data?.maiorProducaoMes || 0)}
            </p>
          </div>

          {/* Footer de Insight 
          <div className="md:col-span-2 bg-[#161b22] p-4 rounded border border-cyan-900/30 flex items-center gap-4">
            <div className="bg-cyan-500/10 p-3 rounded-full text-cyan-400">
              <TrendingUp size={24} />
            </div>
            <div>
              <p className="text-gray-400 text-[10px] uppercase font-bold">Status da Planta</p>
              <p className="text-gray-300 text-xs italic">Dados integrados diretamente do ERP - Atualizado em tempo real.</p>
            </div>
          </div>*/}
        </div>

        {/* Botão Fechar */}
        <div className="p-4 bg-[#0d1117] text-right border-t border-gray-800">
          <button 
            onClick={onClose}
            className="bg-gray-800 hover:bg-gray-700 text-white text-[10px] font-black py-2 px-8 rounded transition-all uppercase tracking-widest shadow-lg"
          >
            Fechar Janela
          </button>
        </div>
      </div>
    </div>
  );
}